(function () {
  var AUTOPLAY_MS = 6000;
  var VISIBLE_COUNT = 5;

  function initSection(section) {
    var id = section.id.replace('sych-reviews-', '');
    var dataEl = document.getElementById('sych-reviews-data-' + id);
    var quoteEl = document.getElementById('sych-reviews-quote-' + id);
    var attrEl = document.getElementById('sych-reviews-attribution-' + id);
    var avatars = Array.prototype.slice.call(section.querySelectorAll('.sych-reviews__avatar'));
    if (!dataEl || avatars.length === 0) return;

    var reviews;
    try {
      reviews = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    var total = avatars.length;
    var current = 0;
    var timer = null;

    function render(index) {
      current = ((index % total) + total) % total;
      var r = reviews[current];
      if (!r) return;

      quoteEl.textContent = '“' + r.quote + '”';
      if (r.linkedin) {
        attrEl.innerHTML = '— <a href="' + r.linkedin + '" target="_blank" rel="noopener noreferrer">' + r.name + '</a>, ' + r.role;
      } else {
        attrEl.textContent = '— ' + r.name + ', ' + r.role;
      }

      // Show a window of VISIBLE_COUNT avatars centered on the active one,
      // positioned via flex `order` so the active avatar always renders in
      // the middle slot regardless of its real index in the full list.
      var half = Math.floor(VISIBLE_COUNT / 2);
      for (var slot = 0; slot < VISIBLE_COUNT; slot++) {
        var offset = slot - half;
        var idx = ((current + offset) % total + total) % total;
        var el = avatars[idx];
        el.classList.remove('is-hidden');
        el.classList.toggle('is-active', offset === 0);
        el.style.order = slot;
      }
      avatars.forEach(function (el, idx) {
        var offset = ((idx - current + total) % total);
        var isVisible = offset <= half || offset >= total - half;
        if (!isVisible) {
          el.classList.add('is-hidden');
          el.classList.remove('is-active');
        }
      });
    }

    function resetTimer() {
      if (timer) clearInterval(timer);
      timer = setInterval(function () { render(current + 1); }, AUTOPLAY_MS);
    }

    avatars.forEach(function (a, i) {
      a.addEventListener('click', function () {
        render(i);
        resetTimer();
      });
    });

    render(0);
    resetTimer();
  }

  function init() {
    document.querySelectorAll('.sych-reviews').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
